import { api } from "@/lib/apiClient";

export type DepartmentListItem = {
  id: string;
  name: string;
  is_active: boolean;
};

export type DepartmentUpsertIn = {
  name: string;
};

export async function listDepartments(include_inactive = false) {
  return api.get<DepartmentListItem[]>("/departments", {
    params: include_inactive ? { include_inactive: true } : undefined,
  });
}

export async function getDepartment(id: string) {
  return api.get<DepartmentListItem>(`/departments/${id}`);
}

export async function createDepartment(body: DepartmentUpsertIn) {
  return api.post<DepartmentListItem>("/departments", body);
}

export async function updateDepartment(id: string, body: DepartmentUpsertIn) {
  return api.put<DepartmentListItem>(`/departments/${id}`, body);
}

export async function setDepartmentActive(id: string, is_active: boolean) {
  return api.patch<DepartmentListItem>(`/departments/${id}/status`, { is_active });
}
